/**
 * Symbol key for the Svelte context that carries the per-class content
 * visibility toggle handlers + pending-id set. BookAccordian provides it;
 * BookAccordianItem and ResourceHolder consume it.
 *
 * Shape:
 *   {
 *     pendingIds: Set<string>,                                  // ids currently being written
 *     toggleTitle(titleId, currentlyHidden): Promise<void>,
 *     toggleItem({ collectionId, itemId, docPath, currentlyHidden }): Promise<void>,
 *   }
 */
export const CONTENT_VISIBILITY_CONTEXT = Symbol('content-visibility');
